import { type ProspectContactDto } from "@crowdcoursing/api/openapi";
import { useState } from "react";

import { useToast } from "~hooks/useToast";

import { useProspectDetails } from "./useProspectDetails";

export const useContactModal = (prospectId: string) => {
  const toast = useToast();
  const { addNewContact, updateExistingContact, deleteContact } = useProspectDetails(prospectId);
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [editContact, setEditContact] = useState<ProspectContactDto | null>(null);
  const [contactToDelete, setContactToDelete] = useState<ProspectContactDto | null>(null);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);

  const handleAddContact = async (
    values: Omit<ProspectContactDto, "id" | "prospectId" | "createdAt" | "updatedAt">,
  ) => {
    try {
      await addNewContact(values);
      setIsAddOpen(false);
      toast.success("Contact added successfully");
    } catch (error) {
      console.error("Error adding contact:", error);
      toast.error("Failed to add contact");
    }
  };

  const handleUpdateContact = async (
    values: Omit<ProspectContactDto, "id" | "prospectId" | "createdAt" | "updatedAt">,
  ) => {
    if (!editContact?.id) {
      return;
    }

    try {
      await updateExistingContact(editContact.id, values);
      setEditContact(null);
      toast.success("Contact updated successfully");
    } catch (error) {
      console.error("Error updating contact:", error);
      toast.error("Failed to update contact");
    }
  };

  const handleDeleteContact = async () => {
    if (!contactToDelete?.id) {
      return;
    }

    try {
      await deleteContact(contactToDelete.id);
      setContactToDelete(null);
      setDeleteConfirmOpen(false);
      toast.success("Contact deleted successfully");
    } catch (error) {
      console.error("Error deleting contact:", error);
      toast.error("Failed to delete contact");
    }
  };

  const openAddModal = () => setIsAddOpen(true);
  const closeAddModal = () => setIsAddOpen(false);
  const openEditModal = (contact: ProspectContactDto) => setEditContact(contact);
  const closeEditModal = () => setEditContact(null);
  const openDeleteModal = (contact: ProspectContactDto) => {
    setContactToDelete(contact);
    setDeleteConfirmOpen(true);
  };
  const closeDeleteModal = () => {
    setDeleteConfirmOpen(false);
    setContactToDelete(null);
  };

  return {
    
    closeAddModal,
    
closeDeleteModal,
    
closeEditModal,
    
contactToDelete,
    
    
deleteConfirmOpen,
    

editContact,
    

// Form handlers
handleAddContact,
    


handleDeleteContact,
    


handleUpdateContact,
    

// Modal states
isAddOpen,
    
    // Modal actions
openAddModal,
    openDeleteModal,
    openEditModal,
  };
};
